import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";
import DateTimesUtils from "core/utils/DateTimesUtils";

const PrevProgTasks = ({item, showPreview}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Td} = useTranslation("datestimes");

    if (!item || Object.keys(item).length === 0) {
        return null;
    }

    const programmingLabel = () => {
        const isPeriodic = item.programming_is_periodic ?? item.is_periodic;
        const every = item.programming_every ?? item.every;
        const repeat = item.programming_repeat ?? item.repeat;
        if (isPeriodic) {
            return `${every || ''} ${repeat || ''}`.trim();
        }
        return item.programming_id ? _Tt('tasks.programmed') : _Tt('tasks.manual');
    };

    const translateValues = () => {
        const repeat = item.programming_repeat || item.repeat;
        const values = item.programming_values || item.values || {};
        let title = "";
        switch (repeat) {
            case "w":
                if (Array.isArray(values.days)) {
                    const days = values.days.map((d) => _Td("days." + d));
                    title = days.join(", ");
                }
                break;
            case "m":
                switch (values.type) {
                    case "d":
                        title = "Dia " + values.day + " de cada mes";
                        break;
                    case "n":
                    case "p":
                        title = _Td("the_place." + values.value) + " " + _Td("days_name." + values.day) + " de cada mes";
                        break;
                    default:
                }
                break;
            case "y":
                switch (values.type) {
                    case "d":
                        title = "Dia " + values.day + " de " + _Td("months_name." + values.value);
                        break;
                    case "n":
                    case "p":
                        title = _Td("the_place." + values.place) + " " + _Td("days_name." + values.day) + " de " + _Td("months_name." + values.value);
                        break;
                    default:
                }
                break;
            default:
                break;
        }
        return title || '-';
    };

    const tasksList = () => {
        if (Array.isArray(item.tasks) && item.tasks.length > 0) return item.tasks.map((t) => t.name).join(", ");
        if (Array.isArray(item.programming_tasks_selected) && item.programming_tasks_selected.length > 0) return item.programming_tasks_selected.map((t) => t.label || t.value).join(", ");
        return '-';
    };

    const getDate = (k1, k2) => item[k1] || item[k2] || null;

    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-title">
                                <label>{_Tt('tasks.name')}</label>
                                <div>{item.name}</div>
                            </div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.description')}</label>
                            <div className="preview-input">{item.description || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.start')}</label>
                            <div className="preview-input">{getDate('programming_date_start','date_start') ? <DateDisplay date={getDate('programming_date_start','date_start')} title={false} /> : '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.end')}</label>
                            <div className="preview-input">{getDate('programming_date_end','date_end') ? <DateDisplay date={getDate('programming_date_end','date_end')} title={false} /> : '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.compile')}</label>
                            <div className="preview-input">{(item.programming_compile || item.compile) ? DateTimesUtils.timeToHourMinute(item.programming_compile || item.compile) : '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.start_hour')}</label>
                            <div className="preview-input">{(item.programming_run || item.run) ? DateTimesUtils.timeToHourMinute(item.programming_run || item.run) : '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.timetable')}</label>
                            <div className="preview-input">{programmingLabel()}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('alerts.value')}</label>
                            <div className="preview-input">{translateValues()}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('notifications.task')}</label>
                            <div className="preview-input">{tasksList()}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevProgTasks;
